__turbopack_context__.v({
  "indeterminate": "LoadingIndeterminate-module__KGvosq__indeterminate",
  "progressBarContainer": "LoadingIndeterminate-module__KGvosq__progressBarContainer",
  "progressBarIndicator": "LoadingIndeterminate-module__KGvosq__progressBarIndicator",
});
